import { Chatbot } from 'features/chatbot/Chatbot'
import { FloatButton } from 'features/chatbot/components/FloatButton'
import { MessageCircle } from 'lucide-react'
import React, { useState } from 'react'

export const ChatbotFloatButton: React.FC = () => {
  const [isChatOpen, setIsChatOpen] = useState(false)

  const toggleChat = () => {
    setIsChatOpen((open) => !open)
  }

  return (
    <FloatButton
      isOpen={isChatOpen}
      onClick={toggleChat}
      icon={<MessageCircle />}>
      <Chatbot onClose={() => setIsChatOpen(false)} />
    </FloatButton>
  )
}
